import script from "./DiagnosisWaring.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiagnosisWaring.vue?vue&type=script&lang=ts&setup=true"

import "./DiagnosisWaring.vue?vue&type=style&index=0&id=db152b9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db152b9a"]])

export default __exports__